/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Momentum_ScoreInputs */

const en_directory_launch_momentum_score = /** @type {(inputs: Directory_Launch_Momentum_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momentum score`)
};

const zh_directory_launch_momentum_score = /** @type {(inputs: Directory_Launch_Momentum_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`动量分`)
};

/**
* | output |
* | --- |
* | "Momentum score" |
*
* @param {Directory_Launch_Momentum_ScoreInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_momentum_score = /** @type {((inputs?: Directory_Launch_Momentum_ScoreInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Momentum_ScoreInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_momentum_score(inputs)
	return zh_directory_launch_momentum_score(inputs)
});
export { directory_launch_momentum_score as "directory.launch.momentum_score" }